import { Dispatch, SetStateAction } from 'react';

import { Box, Typography } from '@mui/material';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS } from 'date-fns/locale';
import dayjs from 'dayjs';

import { useAppSelector } from '@/hooks/redux-hooks';

const AbsoluteSelector = ({
  comparisonDate,
  setComparisonDate,
  comparisonType
}: {
  comparisonDate: Date | null;
  setComparisonDate: Dispatch<SetStateAction<Date | null>>;
  comparisonType: string;
}) => {
  const { userConfig } = useAppSelector(state => state.userConfig);
  const dateFormat = userConfig.dateFormat.value.toUpperCase();
  return (
    <Box
      alignItems='center'
      display='flex'
      flexDirection='column'
    >
      <Box
        alignItems='center'
        display='flex'
        justifyContent='space-around'
        sx={{ backgroundColor: '#272d48', width: 324, height: 30, mt: 1, mb: 1.5 }}
      >
        <Typography>
          {comparisonDate ? dayjs(comparisonDate).format(dateFormat) : dateFormat}
        </Typography>
      </Box>

      {comparisonType === 'absolute' && (
        <LocalizationProvider
          adapterLocale={{
            ...enUS,
            options: {
              ...enUS.options,
              weekStartsOn: 1 // 0 is Sunday, 1 is Monday
            }
          }}
          dateAdapter={AdapterDateFns}
        >
          <StaticDatePicker
            disableFuture
            defaultValue={comparisonDate}
            shouldDisableDate={date => {
              const day = date.getDay();
              return day === 0 || day === 6;
            }}
            slotProps={{
              toolbar: { hidden: true },
              actionBar: {
                actions: []
              }
            }}
            sx={{
              '& .MuiDateCalendar-root': {
                height: 330
              }
            }}
            value={comparisonDate}
            onChange={(value: Date | null) => {
              setComparisonDate(value);
            }}
          />
        </LocalizationProvider>
      )}
    </Box>
  );
};
export default AbsoluteSelector;
